module.exports = __webpack_public_path__ + "static/media/html-css-javascript-lg.b5a4f9e5.jpg";